import { ListLayout } from 'components/common/ListLayout'
import React from 'react'
import toast from 'react-hot-toast';
import { useDispatch, useSelector } from 'react-redux';
import { fetchAppointmentView } from 'slices/appointmentSlice';
import { inviteVendorsSelector, fetchInvitedVendors, fetchAppointmentsVendors } from 'slices/inviteVendorSlice';
import Api from 'services/api';
import Swal from 'sweetalert2';

const AppointedVendorsList = ({ itemId, fetchAppointment, height }) => {
    const dispatch = useDispatch()
    const { invitedVendors, last_page: totalPages } = useSelector(inviteVendorsSelector);
    const appointment = Array.isArray(invitedVendors) ? invitedVendors : (invitedVendors?.invites || [])
    
    const refAddutton = React.useRef(null);
    const [selectedItems, setSelectedItems] = React.useState([]);
    const [selectAll, setSelectAll] = React.useState(false);
    const [deleteModal, setDeleteModal] = React.useState(false);

    const fetchData = async () => {
        dispatch(fetchInvitedVendors(itemId))
    };

    React.useEffect(() => {
        fetchData();
    }, [itemId]);


    const hideConfirmDialog = () => {
        setDeleteModal(false);
    }
    const handleSubmitRemoveVendors = React.useCallback(() => {

        const submitCallback = (success, message) => {
            if (success) {
                toast.success(message, {
                    className: "successToast",
                })
                setSelectedItems([]);
                setSelectAll(false)
                dispatch(fetchAppointmentView(itemId))
                dispatch(fetchInvitedVendors(itemId))
                dispatch(fetchAppointmentsVendors(itemId))
                if (typeof fetchAppointment === 'function') {
                    fetchAppointment()
                }
                hideConfirmDialog()
            }
            else {
                toast.error(message,
                    {
                        className: "errorToast",
                    }
                );
            }
        };
        new Swal({
            title: "Are you sure?",
            text: "You want to Remove them?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes!"
        }).then(async result => {
            if (result.isConfirmed) {
                // We need to implement removeInvitedVendors if needed, 
                // but usually clear-invites clears all for the appointment in this system
                // For now, I'll use the existing clear-invites endpoint via Api directly if not in slice
                const response = await Api.removeInvitedInterpreters(itemId, { vendor_ids: selectedItems });
                if (response.status >= 200 && response.status < 300) {
                    submitCallback(true, response.data.message)
                } else {
                    submitCallback(false, response.data.message)
                }
            }
        })
    }, [selectedItems])

    const handleChange = (e) => {
        const id = e.target.dataset.value
        setSelectedItems(
            selectedItems.includes(id) ?
                selectedItems.filter((item) => item != id) :
                [...selectedItems, id]
        )
    };
    const handleToggleSelectAll = React.useCallback(() => {
        if (selectAll) {
            setSelectedItems([])
            setSelectAll(false)
            return
        }
        setSelectAll(true)
        setSelectedItems(appointment.map((v) => v.vendor?.id?.toString() || v.vendor_id?.toString() || ''))
    }, [selectedItems, selectAll, appointment])



    const renderTableHeader = React.useCallback(() => {

        return (
            <tr>
                <th className="col-1">
                    <div className="row_check">
                        <span>#</span>
                        <label className="custom-checkbox checkbox"><input type="checkbox" name="select-all" checked={selectAll} onChange={handleToggleSelectAll} /><span className="checkmark"></span></label>
                    </div>
                </th>
                <th className="col-5">
                    <div className="" style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                        <p>Name</p>
                    </div>
                </th>
                <th className="col-5">
                    <div className="" style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                        <p>Email</p>
                    </div>
                </th>

            </tr>
        )
    }, [selectedItems, appointment])


    const renderTableContent = React.useCallback(() => {
        return (
            appointment?.map((item, index) => {
                return <AppointedVendorItem item={item?.vendor} index={index} selectedItems={selectedItems} handleChange={handleChange} />
            })
        )
    }, [appointment, selectedItems]);


    const renderFooter = React.useCallback(() => {
        return (
            <div className="row-primary">

                <button
                    onClick={handleSubmitRemoveVendors}
                    disabled={selectedItems?.length == 0}
                    className="main_button"
                    style={{
                        marginRight: 20
                    }}
                >
                    Remove Vendors
                </button>
            </div>
        )
    }, [selectedItems])
    return (
        <>
            <ListLayout
                title="Invited Vendors - Email"
                addButtonDisabled={true}
                buttonTitle="Add InviteVendor"
                renderTableHeader={renderTableHeader}
                renderTableContent={renderTableContent}
                totalPages={totalPages}
                fetchList={fetchData}
                height={height}
                selectedItems={selectedItems}
                refAddutton={refAddutton}
                renderFooter={renderFooter}
                hideRemoveButton={true}
                hidePageLength={true}
                hidePagination={true}
                hideSearchBar={true}
                showRemoveOnTop={true}
                containerStyle={{
                    marginTop: 20
                }}
                time={false}

            >
            </ListLayout>
        </>
    )

};

const AppointedVendorItem = ({
    item, index, selectedItems, handleChange
}) => {
    return (
        <tr>
            <td>
                <div className="row_check">
                    <span>{index + 1}</span>
                    <label className="custom-checkbox checkbox">
                        <input type="checkbox" name="select-all" data-value={item?.id} checked={selectedItems.includes(item?.id?.toString())} onChange={handleChange} />
                        <span className="checkmark"></span>
                    </label>
                </div>
            </td>
            <td>
                {item?.name}
            </td>
            <td>
                {item?.email}
            </td>

        </tr>
    )
}


export default AppointedVendorsList
